var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:[_vm.color],attrs:{"fluid":""}},[_vm._t("default",function(){return [_c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","sm":"8"}},[_vm._t("left")],2),_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","sm":"4"}},[_vm._t("right")],2)],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }